/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import config from 'loracfg';
import CubeGtw from './CubeGtw';
import CloudGtw from './CloudGtw';

const propTypes = {
  gatewayId: React.PropTypes.string.isRequired,
};

class GatewayData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { gatewayId } = this.props;

    return (
      <div>
        {config.profile === 'cube' &&
        <CubeGtw gatewayId={gatewayId} />}
        {config.profile === 'cloud' &&
        <CloudGtw gatewayId={gatewayId} />}
      </div>
    );
  }
}

GatewayData.propTypes = propTypes;

export default GatewayData;




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayData/index.jsx